import React from 'react';
import { useTranslation } from 'react-i18next';

import { usePersonalAddress } from '../../../../hooks';
import { CUSTOMER_EXPERIENCE_PHONE_NUMBER } from '../claimbot.constants';

import styles from './CheckAddressLabel.module.css';

const CheckAddressLabel = () => {
  const { t } = useTranslation('fileClaimbot');
  const { addressLine1, addressLine2, cityStateZip } = usePersonalAddress();

  const addressLine = addressLine2
    ? `${addressLine1} ${addressLine2}` : addressLine1;

  return (
    <div className={styles.container}>
      <span className={styles.title}>
        {t('checkAddressLabel.title')}
      </span>

      <span className={styles.address}>
        {t('checkAddressLabel.address', {
          addressLine1: addressLine,
          cityStateZip,
        })}
      </span>

      <span className={styles.contactMessage}>
        {t('finalCheckMessage', { cxNumber: CUSTOMER_EXPERIENCE_PHONE_NUMBER })}
      </span>
    </div>
  );
};

export { CheckAddressLabel };
